import { POSITION_UPDATE_MUTATION } from 'apollo/mutations/position-mutations';
import { useApolloUpdate } from 'hooks';
import IPosition from 'types/Position';
import { PositionUpdateInput } from '__generated__/graphql';

interface IPositionUpdateResult {
  updatePosition: IPosition[];
}

export default function usePositionUpdate() {
  return useApolloUpdate<PositionUpdateInput, IPositionUpdateResult>(POSITION_UPDATE_MUTATION, 'position');
}
